import {
	DEFAULT_FORMAT,
	DEFAULT_WORKERS,
	EXTENSION_TO_FORMAT,
	IMAGE_EXTENSIONS,
	MAX_WORKERS,
	MIME_TO_FORMAT,
} from "@/constants/image-converter";

export function detectFormat(file: File): string {
	const ext = file.name.split(".").pop()?.toLowerCase() || "";
	return EXTENSION_TO_FORMAT[ext] || MIME_TO_FORMAT[file.type] || DEFAULT_FORMAT;
}

export function isImageFile(file: File): boolean {
	const ext = file.name.split(".").pop()?.toLowerCase() || "";
	return file.type.startsWith("image/") || IMAGE_EXTENSIONS.has(ext);
}

export function getPoolSize(): number {
	if (typeof navigator === "undefined") return DEFAULT_WORKERS;
	const cores = navigator.hardwareConcurrency || DEFAULT_WORKERS;

	// Detect mobile/low-memory devices — limit workers to prevent OOM
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	if (isMobile) {
		return Math.min(cores, 2);
	}

	return Math.min(cores, MAX_WORKERS);
}
